import type { ReactNode } from "react";

import { cn } from "../../lib/cn";

type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

export type HeadingProps = {
    className?: string;
    children: ReactNode;
    level?: HeadingLevel;
};

export function Heading(props: HeadingProps) {
    const level = props.level ?? 1;

    switch (level) {
        case 1:
            return <h1 className={headingClassName(props)}>{props.children}</h1>;
        case 2:
            return <h2 className={headingClassName(props)}>{props.children}</h2>;
        case 3:
            return <h3 className={headingClassName(props)}>{props.children}</h3>;
        case 4:
            return <h4 className={headingClassName(props)}>{props.children}</h4>;
        case 5:
            return <h5 className={headingClassName(props)}>{props.children}</h5>;
        case 6:
            return <h6 className={headingClassName(props)}>{props.children}</h6>;
        default: {
            const exhaustiveLevel: never = level;
            return exhaustiveLevel;
        }
    }
}

const headingBaseClass = "m-0 p-0 font-heading text-case-heading text-text-primary";

const headingLevelClass: Record<HeadingLevel, string> = {
    1: "text-mobile-heading-h1 leading-mobile-heading-h1 font-weight-heading-h1 tracking-heading-large sm-md:text-desktop-heading-h1 sm-md:leading-desktop-heading-h1 sm-md:font-weight-heading-h1",
    2: "text-mobile-heading-h2 leading-mobile-heading-h2 font-weight-heading-h2 tracking-heading-large sm-md:text-desktop-heading-h2 sm-md:leading-desktop-heading-h2 sm-md:font-weight-heading-h2",
    3: "text-mobile-heading-h3 leading-mobile-heading-h3 font-weight-heading-h3 tracking-heading-large sm-md:text-desktop-heading-h3 sm-md:leading-desktop-heading-h3 sm-md:font-weight-heading-h3",
    4: "text-mobile-heading-h4 leading-mobile-heading-h4 font-weight-heading-h4 tracking-heading-large sm-md:text-desktop-heading-h4 sm-md:leading-desktop-heading-h4 sm-md:font-weight-heading-h4",
    5: "text-mobile-heading-h5 leading-mobile-heading-h5 font-weight-heading-h5 tracking-heading-small sm-md:text-desktop-heading-h5 sm-md:leading-desktop-heading-h5 sm-md:font-weight-heading-h5",
    6: "text-mobile-heading-h6 leading-mobile-heading-h6 font-weight-heading-h6 tracking-heading-small sm-md:text-desktop-heading-h6 sm-md:leading-desktop-heading-h6 sm-md:font-weight-heading-h6",
};

function headingClassName(props: HeadingProps) {
    const level = props.level ?? 1;

    return cn(headingBaseClass, headingLevelClass[level], props.className);
}
